import $ from 'jquery';
import PaymentField from './PaymentField';
import PaymentFieldType from './PaymentFieldType';
import SpreedlyService from './SpreedlyService';

export default class SpreedlyField implements PaymentField {
    private readonly _type: PaymentFieldType;
    private readonly _validationErrorElement: JQuery;
    private _isDirty = false;
    private _valueLength = 0;
    private _validationErrorMessage = '';

    constructor(
        type: PaymentFieldType,
        private readonly spreedlyService: SpreedlyService,
    ) {
        this._type = type;
        this._validationErrorElement = $(
            `[data-card-validation="${PaymentFieldType[this._type]}"]`,
        );
    }

    public get validationErrorMessage(): string {
        return this._validationErrorMessage;
    }

    public set validationErrorMessage(value: string) {
        this._validationErrorMessage = value;
    }

    public get type(): PaymentFieldType {
        return this._type;
    }

    public get valueLength(): number {
        return this._valueLength;
    }

    public set valueLength(value: number) {
        this._valueLength = value;
    }

    public setDirtyState(isFormSubmitted: boolean): void {
        if (this._valueLength > 0 || isFormSubmitted) {
            this._isDirty = true;
        }
    }

    public renderErrorMessage(): void {
        if (!this._isDirty) {
            return;
        }

        this._validationErrorElement
            .empty()
            .append(this._validationErrorMessage);
    }

    public focus(): void {
        this.spreedlyService.focus(this.type);
    }
}
